module.exports = __webpack_public_path__ + "media/images/about_solution-pic3-fe2aacff.png";